<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { TrashIcon, PlusIcon, InformationCircleIcon } from '@heroicons/vue/24/outline'
import { ChatBubbleLeftEllipsisIcon, TagIcon, UserCircleIcon, BriefcaseIcon, AcademicCapIcon, PresentationChartLineIcon } from '@heroicons/vue/20/solid'

const props = defineProps(['advertisements', 'showLink']);

const advertisements = ref(JSON.parse(props.advertisements));
const groupedAdvertisements = computed(() => {
    const groupedJobs = {};
    advertisements.value.forEach((job) => {
        const type = job.type;
        if (!groupedJobs[type]) {
            groupedJobs[type] = [];
        }
        groupedJobs[type].push(job);
    });

    const sortedKeys = ['Vollzeit-Job', 'Teilzeit-Job', 'Vollzeit/Teilzeit-Job', 'Mini/Midi-Job', 'Ausbildung', 'Duales Studium'];

    const sortedGroupedJobs = {};
    sortedKeys.forEach((key) => {
        if (groupedJobs[key]) {
            sortedGroupedJobs[key] = groupedJobs[key];
        }
    });

    return sortedGroupedJobs;
});

</script>

<template>
    <template v-for="(jobs, type) in groupedAdvertisements" :key="type">
        <h3 class="tw-text-gray-500 tw-mt-10 tw-text-lg">{{ type }}</h3>
        <div class="tw-mt-2 tw-space-y-2">

            <template v-if="props.showLink">
                <a class="tw-block !tw-no-underline" v-for="job in jobs" :key="job.id"
                    :href="'/stellenangebote/' + job.id">
                    <div
                        class="tw-text-white tw-text-xl tw-py-3 tw-px-4 tw-bg-primary-500/80 tw-backdrop-blur tw-gap-x-2 tw-rounded-lg tw-cursor-pointer hover:tw-bg-primary-400/90 tw-transition">
                        <div class="tw-flex tw-justify-between tw-w-full">
                            <div class="tw-flex tw-gap-x-2 tw-items-center">
                                <span class="tw-font-">{{ job.title }} (m/w/d)</span>
                            </div>
                            <div><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="tw-w-5 tw-h-5 tw-text-primary-200">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </a>
            </template>

            <template v-else>

                <dl class="tw-col-span-3 tw-flex tw-flex-col  tw-text-base tw-leading-7 tw-text-gray-600">
                    <div v-for="job in jobs" :key="job.id"
                        class="tw-text-gray-500 tw-text-lg tw-py-2 tw-px-3 tw-pl-0 tw-gap-x-2 tw-rounded">
                        <div class="tw-flex tw-justify-between tw-w-full">
                            <div class="tw-flex tw-gap-x-2 tw-items-center">
                                <span class="tw-text-primary-500 tw-text-2xl">&bullet;</span>
                                <span>{{ job.title }} (m/w/d)</span>
                            </div>
                        </div>
                    </div>
                </dl>

            </template>

        </div>
    </template>
</template>
